<template>
    <div class="pt20 pb20">
        <div class="rx-bc">
            <div class="formSearch">
                <el-form :inline="true" :model="pageData.formInline" class="demo-form-inline">
                    <el-form-item>
                      <el-select v-model="pageData.formInline.timeIn" @change="changeTimeIn">
                        <el-option v-for="(item, index) in dataList" :key="index" :label="item.label" :value="item.value" />
                      </el-select>
                    </el-form-item>
                    <el-form-item v-if="pageData.formInline.timeIn == -1">
                        <el-date-picker
                            style="height: 32px"
                            v-model="pageData.formInline.searchTime"
                            type="daterange"
                            range-separator="至"
                            format="YYYY-MM-DD"
                            value-format="YYYY-MM-DD"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :disabled-date="pageData.disabledDate"
                        />
                    </el-form-item>
                    <el-form-item v-if="pageData.formInline.timeIn == -2">
                      <el-date-picker
                            style="height: 32px"
                            v-model="pageData.formInline.searchTime"
                            type="monthrange"
                            format="YYYY-MM"
                            value-format="YYYY-MM"
                            range-separator="至"
                            start-placeholder="开始月份"
                            end-placeholder="结束月份"
                            :disabled-date="pageData.setMonthDisabled"
                        />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" :icon="Search" @click="search">搜索</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="mb15 rx-cc">
                <div class="mr20">
                    <span class="color-999 ft12 mr20">温馨提示：当前页面数据仅统计截止至当前时间</span>
                    <a href="javascript:;" class="t_d_u color-409EFF tool_btn ft12" @click="formula">计算公式</a>
                </div>
                <el-button :icon="Upload" @click="getList(true)">导出表格</el-button>
            </div>
        </div>
        <div v-loading="pageData.loading">
            <div class="rx-bc mt5">
                <div class="table h100">
                    <div class="mt20 ml25">
                        <img src="@/assets/h_z.png" alt="">
                        <span class="color-666 fwb v_a_m">实际营收</span>
                    </div>
                    <div class="color-03A3FF ft18 fwb ml30">￥{{ pageData.remark.orderActualMoney }}</div>
                </div>
                <div class="table h100">
                    <div class="mt20 ml25">
                        <img src="@/assets/z_y_s.png" alt="">
                        <span class="color-666 fwb v_a_m">总营收</span>
                    </div>
                    <div class="color-03A3FF ft18 fwb ml30">￥{{ pageData.remark.orderAllMoney }}</div>
                </div>
                <div class="table h100">
                    <div class="mt20 ml25">
                        <img src="@/assets/y_s_t_k.png" alt="">
                        <span class="color-666 fwb v_a_m">营收退款</span>
                    </div>
                    <div class="color-03A3FF ft18 fwb ml30">￥{{ pageData.remark.orderRefundMoney }}</div>
                </div>
                <div class="table h100">
                    <div class="mt20 ml25">
                        <img src="@/assets/y_s_k.png" alt="">
                        <span class="color-666 fwb v_a_m">预收款</span>
                    </div>
                    <div class="color-03A3FF ft18 fwb ml30">￥{{ pageData.remark.orderPreMoney }}</div>
                </div>
                <div class="table h100">
                    <div class="mt20 ml25">
                        <img src="@/assets/y_s_k_t_k.png" alt="">
                        <span class="color-666 fwb v_a_m">预收款退款</span>
                    </div>
                    <div class="color-03A3FF ft18 fwb ml30">￥{{ pageData.remark.orderPreRefundMoney }}</div>
                </div>
                <div class="table h100">
                    <div class="mt20 ml25">
                        <img src="@/assets/c_z_k_b_j_z_f.png" alt="">
                        <span class="color-666 fwb v_a_m">储值卡本金支付</span>
                    </div>
                    <div class="color-03A3FF ft18 fwb ml30">￥{{ pageData.remark.orderStoreBasePayMoney }}</div>
                </div>
                <div class="table h100">
                    <div class="mt20 ml25">
                        <img src="@/assets/c_z_k_z_c_z_f.png" alt="">
                        <span class="color-666 fwb v_a_m">储值卡赠送支付</span>
                    </div>
                    <div class="color-03A3FF ft18 fwb ml30">￥{{ pageData.remark.orderStoreGivePayMoney }}</div>
                </div>
            </div>
            <div class="color-999 mt20 mb15">注：购买储值卡的实收金额算为预收款，储值卡金额抵扣支付其他商品使用后才会纳入营收</div>
            <div>
                <el-table :data="pageData.tableData.slice((pageData.page-1)*pageData.limit, pageData.page*pageData.limit)" stripe >
		    		<el-table-column prop="courseTeacherName" label="商品类目">
                        <template #default="scope">
                            {{ filtersType(scope.row.productType) }}
                        </template>
                    </el-table-column>
		    		<el-table-column label="总营收（元）">
                        <template #default="scope">
                            {{ scope.row.orderAllMoney ? scope.row.orderAllMoney : '-' }}
                        </template>
                    </el-table-column>
		    		<el-table-column label="营收退款（元）">
                        <template #default="scope">
                            {{ scope.row.orderRefundMoney ? scope.row.orderRefundMoney : '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="预收款（元）">
                        <template #default="scope">
                            {{ scope.row.orderPreMoney ? scope.row.orderPreMoney : '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="预收款退款（元）">
                        <template #default="scope">
                            {{ scope.row.orderPreRefundMoney ? scope.row.orderPreRefundMoney : '-' }}
                        </template>
                    </el-table-column>
		    		<el-table-column label="储值卡本金支付（元）">
                        <template #default="scope">
                            {{ scope.row.orderStoreBasePayMoney ? scope.row.orderStoreBasePayMoney : '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="储值卡赠送支付（元）">
                        <template #default="scope">
                            {{ scope.row.orderStoreGivePayMoney ? scope.row.orderStoreGivePayMoney : '-' }}
                        </template>
                    </el-table-column>
		    	</el-table>
                <div class="mt20 rx-ec">
		            <el-pagination
		              v-model:currentPage="pageData.page"
		              :page-sizes="[15,20,30,50,100]"
		              :page-size="pageData.limit"
		              layout="total, sizes, prev, pager, next, jumper"
		              :total="pageData.totalCount"
		              @size-change="classPageSizeChange"
                      @current-change="pageChange"
		            >
		            </el-pagination>
		        </div>
            </div>
        </div>
        <Formula v-model="pageData.formulaShow" :type="'21'"></Formula>
    </div>
</template>

<script setup>
    import { ref, reactive, onMounted } from 'vue';
    import { Search, Upload, Download } from '@element-plus/icons-vue'
    import {ElMessage} from  'element-plus';
    import utils from '@/common/utils.js';
    import Formula from '@/components/branch-store/datacenter/formula.vue';
    import { revenueSummary } from '@/api/dataCenter.js';
    const dataList =[
        { value : "1" , label : '今天' },
        { value : "5" , label : '近7天' },
        { value : "7" , label : '近30天' },
        { value : "8" , label : '近60天' },
        { value : "9" , label : '近90天' },
        { value : "24", label : '近6个月' },
        { value : "25", label : '近12个月' },
        { value : "-1" , label : '自定义日期'},
        { value : "-2" , label : '自定义月份' }
    ]
    const productTypeList = [
		{value: 1, label: '课程卡' },
		{value: 2, label: '入场卡' },
		{value: 3, label: '储值卡购买（预收）' },
		{value: 4, label: '体验卡' },
		{value: 11, label: '团体课' },
		{value: 12, label: '私教课' },
		{value: 13, label: '小班课' }
	]
    const pageData = reactive({
        loading: false,
        formInline: {
            timeIn: '1',
            searchTime: []
        },
        formulaShow: false,
        tableData: [],
        remark: {},
        page:1,
        limit: 15,
        totalCount: 0,
        disabledDate(time) {
          return time.getTime() > new Date().getTime()
        },
        setMonthDisabled(time) {
            // 获取当前的月份信息
            const date = new Date(); // 获取当前的时间基本信息，值是这样的： Tue Jul 20 2021 14:59:43 GMT+0800 (中国标准时间)
            const year = date.getFullYear(); // 获取当前年份，值是这样的： 2021
            let month = date.getMonth() + 1; // 获取当前月份，值是这样的： 6   getMonth()方法返回值是0-11，也就是1月份到12月份，所以要加上1，才是当前月份
            if (month >= 1 && month <= 9) {
              // 如果是1月到9月就要在前面补上一个0   比如：02、07    月份这样表示
              month = "0" + month;
            }
            const nowDate = year.toString() + month.toString(); // 转换成字符串拼接，最终得到年和月，比如此时的时间是2021年7月20号，所以nowDate的值是：202107
            // 获取时间选择器的月份信息
            const timeyear = time.getFullYear(); // 获取时间选择器的年份（有很多）
            let timemonth = time.getMonth() + 1; // 与上面同理
            if (timemonth >= 1 && timemonth <= 9) {
              timemonth = "0" + timemonth;
            }
            const elTimeData = timeyear.toString() + timemonth.toString();

            // 返回，时间选择器的日期月份大于当前日期的月份，又因为disabledDate函数是控制月份禁用不可选
            // 所以，最终就是：时间选择器的月份大于当前的月份，就都禁用掉，所以就实现了最终效果：
            // 大于等于当前月份都不可选 
            return elTimeData > nowDate; // 这里虽然是字符串，但是弱类型语言js会做一个转换，是可以比较大小的如： '202107' > '202008'
        }
    })
    /**
     * @param (String, Number) value-类型, type-1 商品类型 2-支付状态 3-支付方式
     * 表格字段过滤过滤展示
     */
    function filtersType(value) {
        let text = ''
        productTypeList.forEach((item) => {
            if (item.value == value) {
                text = item.label
    		}
        })
        return text
    }
    /**
     * 搜索
     */
    function search() {
        if (pageData.formInline.timeIn == '-1') {
            if (!pageData.formInline.searchTime || !pageData.formInline.searchTime.length) {
                ElMessage({
                    type : 'warning',
                    message : '请选择日期'
                });
                return;
            }
            if (utils.datedifference(pageData.formInline.searchTime[0], pageData.formInline.searchTime[1]) > 31) {
                ElMessage({
                    type : 'warning',
                    message : '自定义日期不能超过31天'
                });
                return;
            }
        }
        if (pageData.formInline.timeIn == '-2') {
            if (!pageData.formInline.searchTime || !pageData.formInline.searchTime.length) {
                ElMessage({
                    type : 'warning',
                    message : '请选择月份'
                });
                return;
            }
            if (utils.MonthsBetw(pageData.formInline.searchTime[0], pageData.formInline.searchTime[1]) > 12) {
                ElMessage({
                    type : 'warning',
                    message : '自定义月份不能超过12个月'
                });
                return;
            }
        }
        pageData.page = 1
        getList()
    }
    /**
     * 获取列表数据
     */
    function getList(isExport) {
        let params = {
            timeIn: pageData.formInline.timeIn,
            searchTime: pageData.formInline.searchTime.join('-'),
            page: pageData.page,
            limit: pageData.limit
        }
        if(isExport){ //导出
			params.exportData = 1;
            params.page = 1
            params.limit = 9999
		}
        revenueSummary(params).then((res) => {
            if (res.code == 0) {
                if (isExport) {
                    ElMessage({
						type: 'success',
						message: '正在导出，请稍后前往下载中心下载'
					})
                } else {
                    pageData.totalCount = res.count
                    pageData.tableData = res.data
                    pageData.remark = res.remark || {}
                }
            }
        })
    }
    /**
     * 计算公式
     */
    function formula() {
        pageData.formulaShow = true
    }
    /**
     * 列表每页条数更改
     */
    function classPageSizeChange(val) {
        pageData.limit = val
    }
    /**
     * 列表分页
     */
    function pageChange(val) {
        pageData.page = val
        getList()
    }
    onMounted(() => {
        getList()
    })
</script>
<style type='css/style' scoped>
    .formSearch ::v-deep .el-form--inline .el-form-item {
        margin-right: 16px;
        margin-bottom: 15px;
    }
    ::v-deep .el-range-editor.el-input__inner {
        padding: 0 10px;
    }
    .table {
        background: #EEF2FF;
        border-radius: 4px;
        width: 13%;
    }
    .table div{
        margin-bottom: 12px;
    }
    .table img{
        width: 24px;
        height: 24px;
        margin-right: 12px;
        vertical-align: middle;
    }
</style>